import { gql } from '@apollo/client'
// Fleet apis

export const LOGIN_FLEET_OWNER = gql`
  query LoginFleetOwner($searchedString: String!, $password: String!) {
    loginFleetOwner(searchedString: $searchedString, password: $password) {
      _id
      email
      mobileNumber
      firstName
      lastName
      authToken
    }
  }
`

export const GET_FLEET_OWNER_BY_MOBILE = gql`
  query GetFleetOwnersByMobileAndName(
    $mobileNumber: String!
    $name: String!
    $pageNumber: Float!
    $pageSize: Float!
  ) {
    getFleetOwnersByMobileAndName(
      mobileNumber: $mobileNumber
      name: $name
      pageNumber: $pageNumber
      pageSize: $pageSize
    ) {
      _id
      id
      firstName
      lastName
      mobileNumber
      emergencyNumber
      birthDate
      address
      city
      state
      operationCity
      driverId
      accountId
      email
      password
      isActive
      created_at
      createdBy
      updated_at
      updatedBy
    }
  }
`
export const GET_FLEETOWNER_BY_DATE = gql`
  query GetFleetOwnersByFromDateToDate(
    $fromDate: DateTime!
    $toDate: DateTime!
    $pageNumber: Float
    $pageSize: Float
  ) {
    getFleetOwnersByFromDateToDate(
      fromDate: $fromDate
      toDate: $toDate
      pageNumber: $pageNumber
      pageSize: $pageSize
    ) {
      total
      fleetOwner {
        _id
        firstName
        lastName
        mobileNumber
        emergencyNumber
        birthDate
        address
        city
        state
        operationCity
        driverId
        accountId
        email
        password
        isActive
        created_at
        createdBy
        updated_at
        updatedBy
      }
    }
  }
`
export const GET_DRIVER_BY_MOBILE = gql`
  query GetDriversByMobileAndName(
    $mobileNumber: String!
    $name: String!
    $operationCity: String!
    $status: String
  ) {
    getDriversByMobileAndName(
      mobileNumber: $mobileNumber
      name: $name
      operationCity: $operationCity
      status: $status
    ) {
      id
      firstName
      middleName
      lastName
      birthDate
      mobileNumber
      emergencyNumber
      address
      google_location
      driverIsA
      permanentAddress
      driverIsA
      licenceIssueDate
      trDate
      ntDate
      experience
      operationCity
      status
      carType
      pvExpiryDate
      driverCode
      licenceExpiryDate
      updatedBy
      accountId {
        id
        balance
      }
      bankName
      ifscCode
      accountNumber
      remark
      driverTraining
      otp
      testScore
      blockedToCustomer {
        customerId
        remark
        customerName
      }
    }
  }
`

export const GET_CABS_BY_FLEET_OWNER = gql`
  query GetCabByFleetOwner($fleetOwnerId: String!) {
    getCabByFleetOwner(fleetOwnerId: $fleetOwnerId) {
      _id
      carNo
      carOwnerName
      rcBook
      puc
      permit
      insurance
      color
      variant
      registrationDate
      registrationExpiryDate
      insuranceExpiryDate
      permitExpiryDate
      pucExpiryDate
      isVerified
      created_at
      createdBy
      updated_at
      updatedBy
      google_location {
        latitude
        longitude
        address
      }
    }
  }
`

export const GET_DRIVERS_BY_FLEET_OWNER = gql`
  query GetDriverByFleetOwner($fleetOwnerId: String!) {
    getDriverByFleetOwner(fleetOwnerId: $fleetOwnerId) {
      _id
      firstName
      middleName
      lastName
      mobileNumber
      email
      otp
      workingStatus
      isActive
      fcmToken
      birthDate
      licenceIssueDate
      ntDate
      trDate
      permanentAddress
      created_at
      createdBy
      updated_at
      updatedBy
      isVerified
    }
  }
`

export const UPDATE_FLEET_DRIVER = gql`
  mutation updateFleetDriver(
    $fleetDriverId: String!
    $updateFleetDriverInput: UpdateFleetDriverInput!
  ) {
    updateFleetDriver(
      fleetDriverId: $fleetDriverId
      updateFleetDriverInput: $updateFleetDriverInput
    ) {
      firstName
      birthDate
    }
  }
`

export const UPDATE_FLEET_CAB = gql`
  mutation updateFleetCab(
    $fleetCabId: String!
    $updateFleetCabInput: UpdateFleetCabInput!
  ) {
    updateFleetCab(
      fleetCabId: $fleetCabId
      updateFleetCabInput: $updateFleetCabInput
    ) {
      _id
    }
  }
`

export const GENERATE_CHECKSUM = gql`
  query GenerateCheckSum($body: String!) {
    generateCheckSum(body: $body)
  }
`
export const GET_FLEET_TRANSACTIONS = gql`
  query GetTransactionsByFleetOwnerId($fleetOwnerId: String!) {
    getTransactionsByFleetOwnerId(fleetOwnerId: $fleetOwnerId) {
      _id
      id
      description
      amount
      transactionStatus
      balance
      status
      bookingId
      transactionId
      created_at
    }
  }
`
export const RECHARGE_FLEET_OWNER = gql`
  mutation RechargeFleetOwner($createRechargeInput: CreateRechargeInput!) {
    rechargeFleetOwner(createRechargeInput: $createRechargeInput)
  }
`

export const AADHAR_VERIFY = gql`
  mutation VerifyAadhaar($aadhaarNumber: String!) {
    verifyAadhaar(aadhaarNumber: $aadhaarNumber)
  }
`
export const VERIFY_OTP = gql`
  mutation VerifyOTP($otp: String!, $ref_id: String!) {
    verifyOTP(otp: $otp, ref_id: $ref_id)
  }
`
